import './ArtistExpandedView.css';
export default {
    "artistExpandedView": "ArtistExpandedView_artistExpandedView__tbzv1",
    "imageWrapper": "ArtistExpandedView_imageWrapper__tbzv1",
    "imageBackground": "ArtistExpandedView_imageBackground__tbzv1",
    "image": "ArtistExpandedView_image__tbzv1",
    "placeholder": "ArtistExpandedView_placeholder__tbzv1",
    "content": "ArtistExpandedView_content__tbzv1",
    "badge": "ArtistExpandedView_badge__tbzv1",
    "name": "ArtistExpandedView_name__tbzv1",
    "tagline": "ArtistExpandedView_tagline__tbzv1",
    "socialMedia": "ArtistExpandedView_socialMedia__tbzv1",
    "bio": "ArtistExpandedView_bio__tbzv1"
};
